import React, { useEffect, useState } from 'react'
import axios from "axios"
import Nav from './nav'
import "./style/Home.css"
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'
import AdBanner from './AdBanner'
import NativeBanner from './NativeBanner'
export default function Home() {
    const [allApp, setAllApp] = useState([])
    const [filteredApps, setFilteredApps] = useState([])
    const [loading, setLoading] = useState(true)
    const [searchTerm, setSearchTerm] = useState('')
    const navigate = useNavigate()

    // Fetch all apps
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const res = await axios.get("https://apkbackend-production-85e8.up.railway.app/allapp")
                console.log("Apps fetched:", res.data.apps)
                setAllApp(res.data.apps)
                setFilteredApps(res.data.apps)
                setLoading(false)
            } catch (error) {
                console.error("Error fetching apps:", error.message)
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    // Real-time search function
    const handleSearch = (searchValue) => {
        console.log("Searching for:", searchValue)
        setSearchTerm(searchValue)
        
        if (searchValue && searchValue.trim() !== '') {
            // Filter apps
            const filtered = allApp.filter(app => 
                app.title.toLowerCase().includes(searchValue.toLowerCase().trim())
            )
            setFilteredApps(filtered)
        } else {
            // If search is empty, show all apps
            setFilteredApps(allApp)
        }
    }

    // Loading state
    if (loading) {
        return (
            <div>
                <Nav onSearch={handleSearch} searchValue={searchTerm} />
                <div className="loading">Loading apps...</div>
                <Footer />
            </div>
        )
    }

    return (
        <div>
            <Nav onSearch={handleSearch} searchValue={searchTerm} />
            <AdBanner />
            {/* Show search results count */}
            {searchTerm && searchTerm.trim() !== '' && (
                <div className="search-info">
                    {/* <p>Showing results for: <strong>"{searchTerm}"</strong> ({filteredApps.length} apps found)</p> */}
                    {filteredApps.length === 0 && (
                        <button onClick={() => handleSearch('')} className="clear-search">
                            Clear Search
                        </button>
                    )}
                </div>
            )}

            <div className="apps">
                {filteredApps.length > 0 ? (
                    filteredApps.map((app, index) => (
                         <React.Fragment key={app._id || index}>
                
                        <div key={app._id || index} className='app'>
                            <img src={app.image} alt={app.title} />
                            <h1>{app.title}</h1>
                            <p>{app.details && app.details.length > 100 
                                ? `${app.details.substring(0, 100)}...` 
                                : app.details}</p>
                            <hr />
                            <button onClick={() => navigate(`/allapp/${app._id}`)}>
                                Read More
                            </button>
                        </div>
                                       {(index + 1) % 3 === 0 && (
                    <div className="native-ad">
                        <NativeBanner />
                    </div>
                )}
                           </React.Fragment>
                    ))
                ) : (
                    <div className="no-results">
                        <h2>🔍 No apps found</h2>
                        <p>We couldn't find any apps matching <strong>"{searchTerm}"</strong></p>
                        <button onClick={() => handleSearch('')} className="clear-search-btn">
                            Show All Apps
                        </button>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    )
}